import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "utils/base-query";

export const partnerPlanApi = createApi({
  reducerPath: "partnerPlanApi",
  tagTypes: ["User"],
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getAllPlans: builder.query({
      query: () => {
        return {
          method: "GET",
          url: "/partner-plan/get-plans",
        };
      },
    }),

    assignPlan: builder.mutation({
      query: ({ partnerId, planId }) => ({
        url: `/partner-plan/partner/${partnerId}/assign-plan/${planId}`,
        method: 'POST',
      }),
    }),
    
    partnerPlanId: builder.query({
      query: ({ partnerId }) => ({
        url: `/partner-plan/get-assigned-plan/${partnerId}`,
        method: 'get',
      }),
    }),

  })
});

export const {
  useGetAllPlansQuery,
  useAssignPlanMutation,
  usePartnerPlanIdQuery,
} = partnerPlanApi;
